document.addEventListener('DOMContentLoaded', function () {
  const menuToggle = document.querySelector('.hamburger');
  const searchToggle = document.querySelector('.search-icon');

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      document.querySelector('.mobile-menu').classList.toggle('dn');
    });
  }
  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      document.querySelector('.mobile-search').classList.toggle('dn');
    });
  }
});
